import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment-jalali';

const Create = () => {

    const {addData} = useEntityCrud('Info/setAnoncement');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        content: '',
        expireDate: '',
        isActive: '1'
    };
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required(),
        content: Yup.string()
        .required() 
    });
    

    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD")
    }

    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        var arr = shamsiDate.split("/");

        return {
            day: parseInt(arr[2]),
            month: parseInt(arr[1]),
            year: parseInt(arr[0]),
        };
    }

    const onSubmit = (values) => {
        debugger
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            content: values.content,
            isActive: values.isActive == 1,
            expireDate: values.expireDate ? convertToDate(values.expireDate) : 0
        };
        addData(postedData).then(({data}) => {
            debugger
            if(data.status){
                toast.success('اطلاعیه جدید با موفقیت ایجاد شد');
                return navigate('/notifications');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/notifications',{replace: true});
    }


    console.log(formik);
    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد اطلاعیه جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;